import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Breadcrumbs, Typography } from '@mui/material';

export const Title = ({ icon, title, breadcrumbs }) => {

  return (
    <Box>
      <Box sx={{ fontSize: '32px', fontWeight: 800 }} data-test-id="title">
        {icon && <FontAwesomeIcon icon={icon} style={{ marginRight: '10px' }} />}
        {title}
      </Box>
      {breadcrumbs &&
        <Breadcrumbs separator={<FontAwesomeIcon icon={fas.faChevronRight} size="xs" />}>
          {breadcrumbs.map(breadcrumb => <Typography key={breadcrumb}>{breadcrumb}</Typography>)}
        </Breadcrumbs>
      }
    </Box>
  );

}

